'use client';
import { useEffect } from 'react';
import { VercelToolbar } from '@vercel/toolbar/next';
import { useRouter, useSearchParams } from 'next/navigation'
import {handleMakeDraft} from "@/app/actions";

export function StaffToolbar({isDraftMode}: {isDraftMode: boolean}) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const isPreview = searchParams.has('preview');
  const makeDraft = searchParams.has('__vercel_draft') || searchParams.has('draft');

  useEffect(() => {
    if (makeDraft && !isDraftMode) {
      handleMakeDraft().then(() => router.refresh()).catch((error) => {
        console.error('Unable to enable draft mode', error);
      });
    }
  }, [makeDraft, isDraftMode, router]);

  if (makeDraft && !isDraftMode) return null;

  if (!isPreview && !isDraftMode) {
    return null;
  }
  return <VercelToolbar />;
}